import React, { useContext, useEffect, useState } from 'react'
import { Checkbox, RadioButton } from '@progress/kendo-react-inputs';
import { PanelBar, PanelBarItem } from '@progress/kendo-react-layout';
import { DropDownList, DropDownListChangeEvent, MultiSelect, MultiSelectChangeEvent, MultiSelectFilterChangeEvent } from '@progress/kendo-react-dropdowns';
import { FeedApi } from '../../../redux/api/FeedApi';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { PartialSpinny } from '../../Nav/Spinny';
import { IFeedConfig } from '../../../types/Feed/IFeedConfig';
import { TeamMultiSelect } from '../../Team/TeamMultiSelect';
import { FieldRenderProps, Form, FormElement } from '@progress/kendo-react-form';
import StaffList from '../../User/ListControls/StaffList';
import ClientTypeList from '../../ClientType/ClientTypeList';
import { ProjectTypeList } from '../../Project/ListControls/ProjectTypeList';
import { Scrollbars } from 'react-custom-scrollbars-2';
import ClientList from '../../Client/ListControls/ClientList';
import { RevUserContext, RevUserContextType } from '../../../context/UserContext';

export const SettingsDialog = (props: FeedDialogProps) => {
    const { profile } = React.useContext<RevUserContextType>(RevUserContext)
    const { data: apiConfig, isFetching } = FeedApi.useGetFeedConfigQuery(profile.Uid)
    const [settings, setSettings] = useState<IFeedConfig>({} as IFeedConfig)
    const [saveFeedSettings, { isLoading: savingConfig }] = FeedApi.useSaveFeedConfigMutation();

    const saveClicked = async () => {
        //Save the feed config
        await saveFeedSettings({ config: settings, uid: profile.Uid });

        props.onSaved();
    }

    //put the API data in state
    useEffect(() => {
        console.log('put the API data in state', apiConfig)
        if (apiConfig)
            setSettings(apiConfig);
    }, [apiConfig]);

    const activityValues = [
        {
            text: `My ${profile?.Phrases.CallPhrase}s`,
            id: 0
        },
        {
            text: `My ${profile?.Phrases.CallPhrase} Monitor`,
            id: 1
        },
        {
            text: `All ${profile?.Phrases.CallPhrase}s`,
            id: 2
        }
    ]

    //Team filter changed
    const teamChanged = (e: MultiSelectChangeEvent) => {
        console.log('team changed', e)

        setSettings((oldval) => {
            return { ...oldval, Filter_Team_Ids: e.value?.map(v => v?.ID).join(',') }
        });
    }
    //Staff changed
    const staffChanged = (e: MultiSelectChangeEvent) => {
        console.log('staff changed', e)

        setSettings((oldval) => {
            return { ...oldval, Filter_Staff_Ids: e.value?.join(',') }
        });
    }
    const clientTypeChanged = (e) => {
        //console.log('client Type changed', e)
        setSettings((oldval) => {
            return { ...oldval, Filter_Client_Type_Ids: e.value?.map(v => v?.ID).join(',') }
        });
    }

    const clientChanged = (e) => {
        setSettings((oldval) => {
            return { ...oldval, Filter_Client_Ids: e.value?.map(v => v?.ID).join(',') }
        });
    }

    const projectTypeChanged = (e) => {
        //console.log('project Type changed', e)
        setSettings((oldval) => {
            return { ...oldval, Filter_Project_Type_Ids: e.value?.map(v => v?.ID).join(',') }
        });
    }

    const emptyProps = {} as FieldRenderProps

    return (
        <Dialog title={"Activity feed settings"} onClose={props.onClose} width={700} className={'feed-settings cool-window'}>

            {(!apiConfig || isFetching || !settings || savingConfig) &&
                <PartialSpinny />
            }
            <Scrollbars style={{ height: '500px' }} >
                <PanelBar style={{ marginRight: '8px' }}>
                    <PanelBarItem expanded={true} title="Display settings">
                        <div className='flex flex-wrap'>
                            <div className='k-form-field w-1/2 p-2'>
                                <label>Activity for</label>
                                <DropDownList dataItemKey='id' textField='text' value={activityValues.find(a => a.id === settings.Activity_For)} onChange={(e: DropDownListChangeEvent) => { setSettings((oldVal) => oldVal = { ...oldVal, Activity_For: e.value.id }) }} data={activityValues} />
                            </div>
                            <div className='k-form-field w-1/2 p-2'>
                                <label>Display most recent</label>
                                <DropDownList value={settings.Recent_Item_Count} onChange={(e: DropDownListChangeEvent) => { setSettings((oldVal) => oldVal = { ...oldVal, Recent_Item_Count: e.value }) }} data={[50, 100, 200]} />
                            </div>
                            <div className='k-form-field  w-1/2 p-2'>
                                <label>Initial visibility</label>
                                <DropDownList dataItemKey='id' textField='text' value={settings.Initial_State ? { id: '1', text: 'Visible' } : { id: '0', text: 'Hidden' }} data={[
                                    {
                                        text: 'Hidden',
                                        id: '0'
                                    },
                                    {
                                        text: 'Visible',
                                        id: '1'
                                    }
                                ]}
                                    onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Initial_State: (v.value.id === '1') } })} />
                            </div>
                            <div className='k-form-field w-1/2 p-2'>
                                <label>Remember visibility</label>
                                <div>
                                    <div className='m-2 inline-block'>
                                        <RadioButton label='Yes' radioGroup='vis' checked={settings.Remember_State === 1} onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Remember_State: 1 } })} />
                                    </div><div className='m-2 inline-block'>
                                        <RadioButton label='No' radioGroup='vis' checked={settings.Remember_State === 0} onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Remember_State: 0 } })} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </PanelBarItem>
                    <PanelBarItem expanded={true} title={`Track these changes ${settings.Options?.filter(o => o.Is_Checked).length}/${settings.Options?.length}`}>
                        <div className='flex flex-wrap'>
                            {settings.Options?.map((o, i) => {
                                return (
                                    <div className='w-1/3 p-1'>
                                        <Checkbox label={o.Display} disabled={o.Visibility !== 1} checked={o.Is_Checked} onChange={(e) => {
                                            setSettings((oldVal) => {
                                                let newState = [...oldVal.Options]
                                                newState[i] = { ...newState[i], Is_Checked: e.value }
                                                return { ...oldVal, Options: newState }
                                            })
                                        }} />
                                    </div>
                                )
                            })}
                        </div>
                    </PanelBarItem>
                    <PanelBarItem expanded={true} title="Filter By">
                        <div className='flex flex-wrap '>
                            <div className='w-full flex flex-wrap'>
                                <div className='w-1/6 flex flex-col-reverse pb-1'>
                                    <label>{profile?.Phrases.Team}/s</label>
                                </div>
                                <div className='w-4/6'>
                                    <div className='w-full'>
                                        <div className='p-2 inline-block' ><RadioButton label='Assigned To' checked={settings.Team_Filter_Option === 0} radioGroup="team-filter" onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Team_Filter_Option: 0 } })} /></div>
                                        <div className='p-2 inline-block' ><RadioButton label='Performed By' checked={settings.Team_Filter_Option === 1} radioGroup="team-filter" onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Team_Filter_Option: 1 } })} /></div>
                                    </div>
                                    <TeamMultiSelect selectedTeamIds={settings.Filter_Team_Ids?.split(',').map(t => parseInt(t))} onChange={teamChanged} />
                                </div>
                            </div>
                            <div className='w-full flex flex-wrap mt-2'>
                                <div className='w-1/6 flex flex-col-reverse pb-1'>
                                    <label>{profile?.Phrases.SupportStaff}</label>
                                </div>
                                <div className='w-4/6'>
                                    <div className='w-full'>
                                        <div className='p-2 inline-block' ><RadioButton label='Assigned To' checked={settings.Staff_Filter_Option === 0} radioGroup="staff-filter" onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Staff_Filter_Option: 0 } })} /></div>
                                        <div className='p-2 inline-block' ><RadioButton label='Performed By' checked={settings.Staff_Filter_Option === 1} radioGroup="staff-filter" onChange={(v) => setSettings((oldVal) => { return { ...oldVal, Staff_Filter_Option: 1 } })} /></div>
                                    </div>
                                    <StaffList multiSelect={true} {...emptyProps} id='staff-list' values={settings.Filter_Staff_Ids?.split(',').map(t => parseInt(t))} onChange={staffChanged} />
                                </div>
                            </div>
                            <div className='w-full flex flex-wrap mt-2'>
                                <div className='w-1/6 flex flex-col-reverse pb-1'>
                                    <label>{profile?.Phrases.Client} Type</label>
                                </div>
                                <div className='w-4/6'>
                                    <ClientTypeList {...emptyProps} placeholder='Select multiple' onChange={clientTypeChanged} clientTypeIds={settings.Filter_Client_Type_Ids?.split(',').map(t => parseInt(t))} />
                                </div>
                            </div>
                            <div className='w-full flex flex-wrap mt-2'>
                                <div className='w-1/6 flex flex-col-reverse pb-1'>
                                    <label>{profile?.Phrases.Client}</label>
                                </div>
                                <div className='w-4/6'>
                                    <ClientList multiSelect={true} {...emptyProps} placeholder='Select multiple' onChange={clientChanged} clientIds={settings.Filter_Client_Ids?.split(',').map(t => parseInt(t))} />
                                </div>
                            </div>
                            <div className='w-full flex flex-wrap mt-2'>
                                <div className='w-1/6 flex flex-col-reverse pb-1'>
                                    <label>{profile?.Phrases.Project} Type</label>
                                </div>
                                <div className='w-4/6'>
                                    <ProjectTypeList multiSelect={true} {...emptyProps} placeholder='Select multiple' onChange={projectTypeChanged} projectTypeIds={settings.Filter_Project_Type_Ids?.split(',').map(t => parseInt(t))} />
                                </div>
                            </div>
                        </div>
                    </PanelBarItem>
                    {/* <PanelBarItem expanded={false} title="Debug">
                        <div style={{ wordBreak: 'break-word' }}>
                            {JSON.stringify(settings)}
                        </div>
                    </PanelBarItem> */}
                </PanelBar>
            </Scrollbars>
            <DialogActionsBar layout={'end'}>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-primary" style={{ color: '#fff', background: profile?.Nav_Hex_Color }}
                    onClick={saveClicked}>
                    Save
                </button>
                <button
                    className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                    onClick={props.onClose}>
                    Cancel
                </button>
            </DialogActionsBar>

        </Dialog >
    )
}

export type FeedDialogProps = {
    onClose: () => void
    onSaved: () => void
}